import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalService } from '@services/modal.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-operations-denied',
  templateUrl: './modal-operations-denied.component.html',
  styleUrls: ['./modal-operations-denied.component.scss'],
})
export class ModalOperationsDeniedComponent implements OnDestroy {
  constructor(public modal: ModalService, private router: Router) {}

  ngOnDestroy() {
    this.modal.close();
  }

  goToStart() {
    this.modal.close();
  }
}
